'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decorateCallbacks = undefined;

var _preferVendorTimestamp = require('../operators/preferVendorTimestamp');

var _RavenWrapper = require('conversations-infrastructure/sentry/RavenWrapper');

/**
 * @description Decorate callbacks of a subscription so that the vendor timestamp is used instead of the client timestamp
 *
 * @param {Object<channelId, messageCallback>} subscriptions subscriptions to decorate
 * @returns {Object<channelId, decoratedCallback} decorated subscriptions
 */
var decorateCallbacks = exports.decorateCallbacks = function decorateCallbacks(subscriptions) {
  var decorated = {};

  Object.keys(subscriptions).forEach(function (channel) {
    var callback = subscriptions[channel];

    // eslint-disable-next-line consistent-return
    decorated[channel] = function (message) {
      try {
        var messageWithCorrectTimestamp = (0, _preferVendorTimestamp.preferVendorTimestamp)(message);
        return callback(messageWithCorrectTimestamp);
      } catch (error) {
        (0, _RavenWrapper.captureException)(error);
        console.error(error);
      }
    };
  });

  return decorated;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/conversations-pub-sub/operators/decorateCallbacks.js
// module id = 796
// module chunks = 2 3